import React from 'react';
export default class ScrollingWrapper extends React.PureComponent {
  render() {
    const {
      children,
      scrollBlock
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      id: scrollBlock
    }, children);
  }
}